const baseUrl = 'https://jesapi.herokuapp.com';
export default baseUrl;
